<template>
  <div class="introduce">
    <drug-guide title="企业简介" :headimg="introHead" :enimg="profile"></drug-guide>
    <div class="introcon">
      <div class="introcon-item">
        <div class="introcon-title">企业概况</div>
        <div class="introcon-line">
          <img :src="centerImg" alt="">
        </div>
        <div class="introcon-desc">
          <img :src="pickerImg" alt="">
          <div class="introcon-desccon">
            <p>贵州汉方药业有限公司（以下简称：汉方药业）成立于1996年，注册资本22154.87万元，主营现代中成药的生产、研发、销售。</p>
            <p>现有员工246人，高级职称6人，中级职称（含执业药师）16人，初级职称10人，本科以上学历87人。</p>
            <p>公司现有专利37项，其中发明专利14项，实用新型专利10项，外观专利4项，有效商标31个。涉及3类、5类、10类、40类、41类、42类，共11类。</p>
            <p>汉方药业是贵州省级企业技术中心，拥有8条GMP药品生产线，含胶囊剂、颗粒剂、片剂等7个现代中药剂型，79个批准文号，其中独家品种19个，专利品种6个，独家苗药7个。含芪胶升白胶囊、妇科再造胶囊、日舒安洗液、黄芪颗粒等重点产品。</p>
            <p>公司财务状况良好且连续多年被评为“AAA级信用企业”、“贵州企业100强企业”。2022年主营业务收入4.66亿元。</p>
            <p>汉方药业生产基地位于白云区沙文镇，占地99亩，建筑面积约15万平方米。于2016年1月建成现代化中药制药生产线，并通过GMP认证后批量投产。其中颗粒剂、胶囊剂为目前西南地区最大的生产线。</p>
            <p>汉方药业先后被评定为贵州省高新技术企业，AAA级信用企业，贵州企业100强企业，贵州民营企业100强企业，千企改造工程龙头企业，贵州省省级企业技术中心，贵州省智能制造试点示范企业，贵阳高新区大数据+智能制造试点示范企业，贵阳高新区十大纳税企业。此外，公司黄芪颗粒、日舒安洗液、妇科再造胶囊、芪胶升白胶囊、儿童回春颗粒与天麻灵芝合剂先后被评为贵州省名牌产品。</p>
            <p>公司积极响应《中医药“一带一路”发展规划(2016-2020年)》相关政策以及贵州省下发的《关于支持苗药做大做强若干政策措施的通知》规定，大力发展中药产品，力争将具有优势的中药做深做强做大。研究方向以“中医药创新发展规划纲要”( 2006－2020)重点提出的“选择疗效确切的传统中药进行深入细致的系统研究和开发(二次开发)”的发展规划为导向，积极开展中药的系统研究，着力于经典名方的工艺改造、质量标准控制、有效物质基础探寻、临床定位和提高临床有效性、以及安全性评价与合理用药的二次开发研究，以期提升产品内在品质和安全性。目前在研究项目有：贵州省科技科技计划：妇科再造胶囊生殖安全质量控制研究（项目编号：黔科合支撑【2019】2783号）、苗药芪胶升白胶囊技术改造及再评价研究后成果产业化运用（项目编号：黔科合成果【2020】4Y031），委托在研项目：“妇科再造胶囊生殖与发育毒性伴随毒代动力学开发研究，是贵州省首家对药物进行生殖毒性安全性研究，揭示妇科再造胶囊对生殖繁育毒性的影响。</p>
            <p>汉方药业立志在中药健康领域中，提供专业的、民族的、创新的、高品质的产品与服务，满足人民健康需求。并借此成为一个具有强大影响力，与员工及社会共享发展成果的卓越企业。公司兼容并蓄，四方纳贤，与时俱进，勇于开拓创新，秉承“德为本 制良药”的经营理念，践行”崇德、至善、坚持、担当、探索、开拓、共享、自由”的价值观，通过汉方药业这个健康平台，成就合作伙伴和员工的事业梦想，并在此收获快乐。</p>
          </div>
        </div>
      </div>
      <div class="introcon-item">
        <div class="introcon-title" style="margin-top: 34px;">企业文化</div>
        <div class="introcon-line">
          <img :src="centerImg" alt="">
        </div>
        <div class="introcon-cate">
          <div  :class="hoveredidx == index ? 'catelist on' : 'catelist'"   v-for="(item, index) in cateList" :key="index"  @mouseover="setitem(index)" @mouseleave="setitem(-1)">
            <img :src="item.icon" alt="">
            <div class="catelist-title">{{ item.title }}</div>
            <div class="catelist-desc">{{ item.desc }}</div>
          </div>
        </div>
        <div class="introcon-policy">
          <div class="policy-title">核心价值观</div>
          <div class="policy-desc">崇德、至善、坚持、担当、探索、开拓、共享、自由</div>
          <div class="policylist">
            <div :class="policyidx == index ? 'policyitem on' : 'policyitem'" v-for="(item, index) in policyList" :key="index" @click="getPolicy(index)">
              <img :src="policyBg" alt="">
              <div>{{ item.title }}</div>
            </div>
          </div>
        </div>
        <div class="introcon-ground">
          <img :src="ground" alt="">
        </div>
      </div>
      <div class="introcon-item">
        <div class="introcon-title" style="margin-top: 34px;">荣誉历程</div>
        <div class="introcon-line">
          <img :src="centerImg" alt="">
        </div>
        <div class="introcon-honor">
          <div class="honorlist" v-for="(item, index) in honorList" :key="index">
            <img :src="item.thumb" alt="">
            <div class="honorlist-title">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <drug-footer></drug-footer>
  </div>
</template>

<script>
import DrugFooter from "../../components/DrugFooter";
import DrugGuide from "../../components/DrugGuide";
export default {
  name: "Introduce",
  components: {
    DrugFooter,
    DrugGuide
  },
  data() {
    return {
      isHovered: false,
      introHead: "static/images/introduce/intro-head.png",
      profile: "static/images/introduce/intro-profile.png",
      centerImg: 'static/images/introduce/intro-center.png',
      pickerImg: 'static/images/introduce/intro-picker.png',
      cateList: [
        {
          icon: "static/images/introduce/intro-cate01.png",
          title: "企业使命",
          desc: "创造人类健康生活"
        },
        {
          icon: "static/images/introduce/intro-cate02.png?v=1.1",
          title: "企业愿景",
          desc: "成为国人信赖的制药企业"
        },
        {
          icon: "static/images/introduce/intro-cate03.png",
          title: "经营理念",
          desc: "德为本，制良药"
        },
        {
          icon: "static/images/introduce/intro-cate04.png",
          title: "生产理念",
          desc: "仁心用料，精益制造"
        },
        {
          icon: "static/images/introduce/intro-cate05.png",
          title: "财务理念",
          desc: "诚信合规，专业高效"
        },
        {
          icon: "static/images/introduce/intro-cate06.png",
          title: "研发理念",
          desc: "以患者为中心，以疗效为核心"
        },
        {
          icon: "static/images/introduce/intro-cate07.png",
          title: "销售理念",
          desc: "高效执行、创新融合、结果导向"
        },
        {
          icon: "static/images/introduce/intro-cate08.png",
          title: "品牌理念",
          desc: "以口碑塑造品牌"
        },
        {
          icon: "static/images/introduce/intro-cate09.png",
          title: "用人理念",
          desc: "以德为先，知行合一"
        },
        {
          icon: "static/images/introduce/intro-cate10.png",
          title: "发展理念",
          desc: "以长期价值为原则，专注制药，稳健发展"
        },
      ],
      policyBg: "static/images/introduce/intro-policy.png",
      ground: "static/images/introduce/intro-ground.png",
      policyList: [
        {
          title: "崇德—恪守仁心，以道德品质为底线。"
        },
        {
          title: "至善—止于至善，以追求卓越为目标。"
        },
        {
          title: "坚持—做好过程中的每一个细节，坚持每一件事都有一个结果，坚守心中的底线，坚持共同的梦想。"
        },
        {
          title: "担当—做好自己该做的，对结果负责任；肩负他人欠缺的，对团队负责任。"
        },
        {
          title: "探索—渴求未知，勇于创新；敢于实践，容错纠错。"
        },
        {
          title: "开拓—突破陈规，敢为人先；先行先试，求真求实。"
        },
        {
          title: "共享—以团队为本，相互尊重，融洽共处，以奋斗者为荣，携手共进，共享成果。"
        },
        {
          title: "自由—热爱生命，心向往之。"
        },
      ],
      policyidx: -1,
      hoveredidx:-1,
      honorList: [
        {
          thumb: "static/images/introduce/intro-honor01.png",
          title: "中国民营企业文化建设先进单位"
        },
        {
          thumb: "static/images/introduce/intro-honor02.png",
          title: "贵州省行业第一品牌"
        },
        {
          thumb: "static/images/introduce/intro-honor03.png",
          title: "中国品牌文化影响力十大最具价值品牌"
        },
        {
          thumb: "static/images/introduce/intro-honor04.png",
          title: "2018贵州企业100强"
        },
        {
          thumb: "static/images/introduce/intro-honor05.png",
          title: "中国品牌文化影响力十大最具价值品牌"
        },
        {
          thumb: "static/images/introduce/intro-honor06.png",
          title: "中国民营企业文化建设先进单位"
        },
        {
          thumb: "static/images/introduce/intro-honor07.png",
          title: "中国品牌文化影响力十大最具价值品牌"
        },
        {
          thumb: "static/images/introduce/intro-honor08.png",
          title: "中国品牌文化影响力十大最具价值品牌"
        },
        {
          thumb: "static/images/introduce/intro-honor09.png",
          title: "中国品牌文化影响力十大最具价值品牌"
        },
        {
          thumb: "static/images/introduce/intro-honor10.png",
          title: "中国品牌文化影响力十大最具价值品牌"
        },
        {
          thumb: "static/images/introduce/intro-honor11.png",
          title: "中国民营企业文化建设先进单位"
        },
        {
          thumb: "static/images/introduce/intro-honor12.png",
          title: "中国品牌文化影响力十大最具价值品牌"
        },
      ]
    }
  },
  mounted() {
    this.$store.commit("getactive", 1);
  },
  methods: {
    getPolicy(index) {
      this.policyidx = index;
    },
    setitem(index) {
      this.hoveredidx = index;
    }
  }
}
</script>

<style lang="scss" scoped>
  .introduce {
    .introcon {
      width: 80%;
      height: auto;
      background-color: #fff;
      margin: 20px auto 0 auto;
      padding: 55px 0 20px 0;
      .introcon-item {
        margin: 0 20px 0 20px;
        .introcon-title {
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-size: 28px;
          font-family: "PingFang SC-Medium", "PingFang SC";
        }
        .introcon-line {
          width: 100%;
          img {
            width: 100%;
          }
        }
        .introcon-desc {
          margin: 30px auto 0 auto;
          width: 90%;
          img {
            width: 100%;
          }
          .introcon-desccon {
            margin-top: 31px;
            padding: 0 12px;
            line-height: 38px;
            font-size: 16px;
            text-indent: 2em;
          }
        }
        .introcon-cate {
          width: 90%;
          overflow: hidden;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 39px auto 0 auto;
          .catelist {
            width: 19%;
            height: 226px;
            padding: 34px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            font-size: 16px;
            background: #ECF5FF;
            color: #002244;
            cursor: pointer;
            margin-bottom: 20px;
            &.on {
              background: linear-gradient(180deg, #B1FAFF 0%, #4392EC 100%);
              color: #fff;
            }
            img {
              width: 42px;
              height: 42px;
              margin: 13px 0 18px 0;
            }
            .catelist-title {
              height: 40px;
              line-height: 40px;
              font-size: 18px;
              font-family: "PingFang SC-Medium", "PingFang SC";
            }
            .catelist-desc {
              text-align: center;
            }
          }
        }
        .introcon-policy {
          width: 90%;
          height: 521px;
          margin: 14px auto 0 auto;
          background: #ECF5FF;
          padding-top: 36px;
          .policy-title {
            font-size: 21px;
            text-align: center;
            height: 40px;
            line-height: 40px;
            font-family: "PingFang SC-Medium", "PingFang SC";
          }
          .policy-desc {
            font-size: 18px;
            text-align: center;
            height: 40px;
            line-height: 40px;
          }
          .policylist {
            width: 90%;
            height: 370px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin: 23px auto 0 auto;
            .policyitem {
              width: 49%;
              box-sizing: border-box;
              height: 70px;
              position: relative;
              box-sizing: border-box;
              cursor: pointer;
              &.on {
                border: 2px dashed #ccc;
              }
              img {
                width: 100%;
                height: 100%;
              }
              div {
                position: absolute;
                top: 0;
                height: 100%;
                padding: 0 18px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                z-index: 10;
              }
            }
          }
        }
        .introcon-ground {
          width: 90%;
          margin: 50px auto 0 auto;
          img {
            width: 100%;
          }
        }
        .introcon-honor {
          width: 90%;
          height: auto;
          margin: 55px auto 0 auto;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          .honorlist {
            width: 24%;
            margin-bottom: 20px;
            margin-right: 1%;
            img {
              width: 100%;
              display: block;
            }
            .honorlist-title {
              width: 100%;
              height: 87px;
              line-height: 28px;
              padding: 18px 35px;
              box-sizing: border-box;
              text-align: center;
              background: #ECF5FF;
            }
          }
          .honorlist:nth-of-type(4n+4) {
            margin-right: 0;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/introduce/introduce.vue